import dayjs from "dayjs";
import "dayjs/locale/es"; // Importa el locale en español
import updateLocale from "dayjs/plugin/updateLocale"; // Para modificaciones personalizadas del locale si las necesitas

export const formatMoney = (money) =>
    new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    }).format(Number(money) || 0);

export const formatNumber = (number) =>
    new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(Number(number) || 0);

export const formatTime = (time) => {
    if (typeof time !== "string" || !time.includes(":")) {
        return time ?? "";
    }

    return time.split(":").slice(0, 2).join(":");
};

export const formatDate = (dateString, showWeekDay = true) => {
    dayjs.locale("es");

    const date = dayjs(dateString);

    const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
    ];
    const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
    ];

    const weekDay = days[date.day()];
    const day = date.date();
    const month = months[date.month()];
    const year = date.year();

    return `${showWeekDay ? weekDay + " " : ""}${day} de ${month} del ${year}`;
};

export const formatDateString = (
    dateString,
    showWeekDay = true,
    showTime = false
) => {
    dayjs.locale("es");

    const date = dayjs(dateString);

    const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
    ];
    const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
    ];
    const weekDay = days[date.day()];
    const day = date.date();
    const month = months[date.month()];
    const year = date.year();
    const hour = date.format("HH");
    const minute = date.format("mm");

    return `${showWeekDay ? weekDay + " " : ""}${day} de ${month} del ${year}${
        showTime ? ` a las ${hour}:${minute}` : ""
    }`;
};

export const capitalizeFirstLetter = (string) => {
    if (!string) return ""; // Manejar el caso de una cadena vacía
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

//* Elimina tildes y pone todo en minúsculas
export const normalizeString = (str) => {
    if (!str || typeof str !== "string") {
        return "";
    }

    return str
        .normalize("NFD") // separa letras de sus tildes (á → a + ́)
        .replace(/[\u0300-\u036f]/g, "") // elimina tildes
        .toLowerCase();
};

export const normalizeStringUpperCase = (str = "") => {
    if (!str) {
        return "";
    }

    return str
        .normalize("NFD") // Descompone los acentos
        .replace(/[\u0300-\u036f]/g, "") // Elimina los diacríticos
        .toUpperCase(); // Convierte a mayúsculas
};

export const formatPercentage = (value) => {
    if (value === null || value === undefined) {
        return "—";
    }

    const num = Number(value);
    if (isNaN(num)) {
        return "—";
    }

    return (
        new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(num) + "%"
    );
};

export const formatDateFormat = (dateString = null, format = "DD/MM/YYYY") => {
    const date = dateString ? dayjs(dateString) : dayjs();
    return date.format(format);
};

export const formatHour12 = (time) => {
    if (!time) return null;
    return dayjs(time, "HH:mm").format("h:mma");
};

export function diffHoursMinutes(start, end) {
    if (!start || !end) return null;

    const s = dayjs(start, "HH:mm");
    const e = dayjs(end, "HH:mm");

    const diffMinutes = e.diff(s, "minute");

    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;

    if (hours > 0 && minutes > 0) {
        return `${hours}h ${minutes}min`;
    }

    if (hours > 0 && minutes === 0) {
        return `${hours}h`;
    }

    return `${minutes}min`;
}
